// Review sync polling helpers. Split out so ReviewSyncControl.tsx only exports
// components (react-refresh/only-export-components).

import type { ReviewSummary } from '../../api/reviews.types'

// Poll the summary while a background sync is running; stop once it ends.
const SYNC_POLL_MS = 2000

export function syncPollInterval(summary: ReviewSummary | undefined): number | false {
  return summary?.sync_progress?.running ? SYNC_POLL_MS : false
}
